import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import "./ContactPageFormView.css";
import ContactsHeader from "./ContactsHeader";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";//command

const ContactPageFormView = () => {
  const [clientData, setClientData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch data from API
  useEffect(() => {
    fetchClientData();
  }, []);

  const fetchClientData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_feedback_Aplication_Form"
      );
      setClientData(response.data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  // Filter Data
  const filteredData = clientData.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Download Filtered Data as CSV
  const handleDownload = () => {
    const csvData = [
      ["Name", "Contact No", "Email ID", "Type", "Message", "Date"],
      ...filteredData.map((item) => [
        item.name,
        item.mobile,
        item.email,
        item.type,
        item.message,
        item.date,
      ]),
    ];

    const csvContent = csvData.map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "client_data.csv");
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ContactsHeader />
      <div className="container mt-4 ClientForm-admin">
        <div className="d-flex justify-content-around">
          <h2 className="text-center mb-4">Enquiry Form</h2>

          <div className="dropdown">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Select
            </button>

            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <a className="dropdown-item" href="/adminclientform">
                  Client Form
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/admincandidateform">
                  Candidate Form
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/admincontactus">
                  Enquiry Form
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Search Filter */}
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search by any field..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          required
        />

        {/* Data Table */}
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Contact No</th>
                <th>Action</th>
                <th>Email ID</th>
                <th>Type</th>
                <th>Message</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.mobile}</td>
                    <td>
                      <a
                        href={`https://wa.me/91${item.mobile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaWhatsapp
                          size={20}
                          color="green"
                          style={{ marginRight: "8px" }}
                        />
                      </a>
                      <a href={`tel:+91${item.mobile}`}>
                        <FaPhoneAlt size={20} color="blue" />
                      </a>
                    </td>
                    <td>{item.email}</td>
                    <td>{item.type}</td>
                    <td>{item.message}</td>
                    <td>{item.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Download Button */}
        <button
          className="btn btn-primary"
          onClick={handleDownload}
          disabled={filteredData.length === 0}
        >
          Download Filtered Data
        </button>
      </div>
    </>
  );
};

export default ContactPageFormView;
